export default __webpack_public_path__ + "static/media/alphabet-yellow-c.d087c95b.png";